<script>
    export let region;

    import hydros from './hydrosSVG.js';

    $: region_slug = region.toLowerCase().replaceAll(" ","-");
    
</script>
<div class="mini-hydro-map">
<svg id="hydros" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 147.9072 170.4846">
    {#each hydros as h }
        <path
            id={h.name}
            fill={ 
                region_slug != "statewide" ?
                region_slug == h.name ? 
                "#8bb8c9" : "#ccc" : "#8bb8c9"
            }
            stroke="#fefefe"
            d={h.path}
        />
    {/each}
</div>